import { useState } from 'react';
import { useQueryClient } from 'react-query';

import { useSubscribeQuery } from './useSubscribeQuery';

export const useQueryData = (queryKey, filters = {}) => {
  const queryClient = useQueryClient();

  const [data, setData] = useState(() =>
    queryClient.getQueryData(queryKey, { exact: false, ...filters })
  );

  useSubscribeQuery({ queryKey, status: 'success', ...filters }, (query) => {
    setData(query.state.data);
  });

  return data;
};
